var React = require('react');

function ArrowAltLeft (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M424 320H224V191.89h200a24 24 0 0 1 24 24V296a24 24 0 0 1-24 24z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M183 440.92L7 273a24.06 24.06 0 0 1 0-34L183 71.09c15.1-15.11 41-4.4 41 17v335.83c0 21.42-25.76 32.13-41 17z","className":"fa-primary","key":2})]);
}

ArrowAltLeft.defaultProps = {"viewBox":"0 0 448 512","className":"icon"};

module.exports = ArrowAltLeft;

ArrowAltLeft.default = ArrowAltLeft;
